import { render, staticRenderFns } from "./AgregarACatalogo.vue?vue&type=template&id=bced57d0&scoped=true&"
import script from "./AgregarACatalogo.vue?vue&type=script&lang=js&"
export * from "./AgregarACatalogo.vue?vue&type=script&lang=js&"
import style0 from "./AgregarACatalogo.vue?vue&type=style&index=0&id=bced57d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced57d0",
  null
  
)

export default component.exports